import React from 'react';
import { PropTypes } from 'prop-types';

import ModalWrapper from 'components/Modals/ModalWrapper';

const ChangeOwnershipModal = ({
  isShown,
  onAssign,
  onContinueWithoutAssign,
  onCancel,
  workflowRecord,
  btnCancelClass,
  btnCancelTitle,
  btnAssignToMeClass,
  btnAssignToMeTitle,
  btnContinueWithoutAssignClass,
  btnContinueWithoutAssignTitle,

}) => (
  <ModalWrapper
    headerClose={ false }
    isOpen={ isShown }
    showFooter={ false }
    title="Assign this item to me"
    modalSize="change-ownership-modal"
  >
    <p>
      { workflowRecord != null && workflowRecord.currentUserFullName && <span>This item is currently worked on by <b>{ workflowRecord.currentUserFullName }</b>.<br /></span> }
      Do you want to take ownership?<br />
      Click &quot;Assign to me&quot; to move this to your workflow.
    </p>
    <div className="modal-footer">
      { <button
        type="button"
        className={ `btn btn-link ${ btnCancelClass }` }
        onClick={ () => onCancel() }
      >{ btnCancelTitle }</button> }
      { <button
        type="button"
        className={ `btn btn-link ${ btnContinueWithoutAssignClass }` }
        onClick={ () => onContinueWithoutAssign() }
      >{ btnContinueWithoutAssignTitle }</button> }
      { <button
        type="button"
        className={ `btn ${ btnAssignToMeClass }}` }
        onClick={ () => onAssign() }
      > {btnAssignToMeTitle} </button> }
    </div>
  </ModalWrapper>
);

ChangeOwnershipModal.propTypes = {
  isShown: PropTypes.bool,
  onAssign: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onContinueWithoutAssign: PropTypes.func.isRequired,
  workflowRecord: PropTypes.shape().isRequired,
  btnCancelTitle: PropTypes.string,
  btnCancelClass: PropTypes.string,
  btnAssignToMeClass: PropTypes.string,
  btnAssignToMeTitle: PropTypes.string,
  btnContinueWithoutAssignClass: PropTypes.string,
  btnContinueWithoutAssignTitle: PropTypes.string,

};

ChangeOwnershipModal.defaultProps = {
  isShown: false,
  btnCancelTitle: 'Cancel',
  btnCancelClass: 'float-left',
  btnAssignToMeClass: 'btn-danger',
  btnAssignToMeTitle: 'Assign to Me',
  btnContinueWithoutAssignClass: '',
  btnContinueWithoutAssignTitle: 'Continue without Assigning',
};

export default ChangeOwnershipModal;
